import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

const CustomAlert = ({ show, type = "success", message, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => onClose(), 3000); // auto close in 3s
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  const isSuccess = type === "success";
  const Icon = isSuccess ? FaCheckCircle : FaExclamationCircle;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -30 }}
          transition={{ duration: 0.3 }}
          className={`fixed top-6 right-6 z-50 flex items-center space-x-3 px-5 py-3 rounded-lg shadow-lg border-l-4 ${
            isSuccess
              ? "bg-green-50 border-green-600 text-green-800"
              : "bg-red-50 border-red-600 text-red-800"
          }`}
        >
          <Icon
            className={`text-xl ${
              isSuccess ? "text-green-600" : "text-red-600"
            }`}
          />
          <span className="font-medium">{message}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CustomAlert;
